import { render, staticRenderFns } from "./GreetingsMessage.vue?vue&type=template&id=6fb4edd6&scoped=true&"
import script from "./GreetingsMessage.vue?vue&type=script&lang=js&"
export * from "./GreetingsMessage.vue?vue&type=script&lang=js&"
import style0 from "./GreetingsMessage.vue?vue&type=style&index=0&id=6fb4edd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb4edd6",
  null
  
)

export default component.exports